var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "pages-available" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("dash.inbox.available_users")) + "\n    "
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "search-page" },
          [
            _c("vs-input", {
              staticClass: "inputx",
              class: { input: true },
              attrs: {
                color: "#B20564",
                "icon-after": "true",
                icon: "search",
                placeholder: _vm.$t("dash.inbox.label.user_filter"),
              },
              model: {
                value: _vm.userFilter,
                callback: function ($$v) {
                  _vm.userFilter = $$v
                },
                expression: "userFilter",
              },
            }),
          ],
          1
        ),
        _c(
          "ul",
          _vm._l(_vm.allUsers, function (item) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "page",
                class: [
                  {
                    hide: !_vm.checkUserFilter(item),
                    select: _vm.selectedToAdd.find((p) => p.id == item.id),
                  },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectAvailable(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: `${item.lastname} ${item.firstname} (${item.email})`,
                            position: "top",
                          },
                        },
                        [
                          !item.avatar || !item.avatar.length
                            ? _c("vs-avatar", {
                                attrs: {
                                  color: "#f9f9f9",
                                  size: "42px",
                                  src: require("../../../assets/img/ico-man.svg"),
                                },
                              })
                            : item.avatar && !!item.avatar.length
                            ? _c("vs-avatar", { attrs: { src: item.avatar } })
                            : _vm._e(),
                          _c("p", { staticClass: "page-name" }, [
                            _vm._v(
                              _vm._s(
                                `${item.lastname} ${item.firstname} (${item.email})`
                              )
                            ),
                          ]),
                          _vm._v("\n                 \n              "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "actions" }, [
      !_vm.unique
        ? _c("div", { staticClass: "all", on: { click: _vm.all } }, [
            _c("img", {
              attrs: {
                src: require("../../../assets/img/icon-RAZ.svg"),
                alt: "icon RAZ",
              },
            }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "add", on: { click: _vm.add } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-right-arrow.svg"),
            alt: "icon right arrow",
          },
        }),
      ]),
      _c("div", { staticClass: "remove", on: { click: _vm.remove } }, [
        _c("img", {
          attrs: {
            src: require("../../../assets/img/icon-left-arrow.svg"),
            alt: "icon left arrow",
          },
        }),
      ]),
      !_vm.unique
        ? _c("div", { staticClass: "raz", on: { click: _vm.raz } }, [
            _c("img", {
              attrs: {
                src: require("../../../assets/img/icon-RAZ.svg"),
                alt: "icon RAZ",
              },
            }),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "pages-affected" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t(`dash.inbox.user_selected${_vm.unique ? ".unique" : ""}`)
          )
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "ul",
          _vm._l(_vm.users, function (item, index) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "page",
                class: [
                  { select: _vm.selectedToRemove.find((p) => p.id == item.id) },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectAffected(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: `${item.lastname} ${item.firstname} (${item.email})`,
                            position: "top",
                          },
                        },
                        [
                          !item.avatar || !item.avatar.length
                            ? _c("vs-avatar", {
                                attrs: {
                                  color: "#f9f9f9",
                                  size: "42px",
                                  src: require("../../../assets/img/ico-man.svg"),
                                },
                              })
                            : item.avatar && !!item.avatar.length
                            ? _c("vs-avatar", { attrs: { src: item.avatar } })
                            : _vm._e(),
                          _c("p", { staticClass: "page-name" }, [
                            _vm._v(
                              _vm._s(
                                `${item.lastname} ${item.firstname} (${item.email})`
                              )
                            ),
                          ]),
                          _vm._v("\n                 \n              "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "position" }, [
                    _c(
                      "div",
                      {
                        staticClass: "top",
                        class: [{ disable: index == 0 }],
                        on: {
                          click: function ($event) {
                            return _vm.changePosition(index, index - 1)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "hide-group",
                          attrs: {
                            alt: "top",
                            src: require("../../../assets/img/icon-hide-group.svg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bottom",
                        class: [{ disable: index == _vm.users.length - 1 }],
                        on: {
                          click: function ($event) {
                            return _vm.changePosition(index, index + 1)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "hide-group",
                          attrs: {
                            alt: "bottom",
                            src: require("../../../assets/img/icon-hide-group.svg"),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "submit" },
      [
        _vm.type == "affected_to"
          ? _c("div", { staticClass: "option_validation" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.optionValidation,
                      expression: "optionValidation",
                    },
                  ],
                  attrs: { type: "checkbox", name: "option_validation" },
                  domProps: {
                    checked: Array.isArray(_vm.optionValidation)
                      ? _vm._i(_vm.optionValidation, null) > -1
                      : _vm.optionValidation,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.optionValidation,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.optionValidation = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.optionValidation = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.optionValidation = $$c
                      }
                    },
                  },
                }),
                _vm._m(0),
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("dash.post.option_validation")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _c(
          "vs-button",
          {
            staticClass: "validate",
            attrs: { color: "#6a1f4c" },
            on: { click: _vm.submit },
          },
          [_c("p", [_vm._v(_vm._s(_vm.$t("dash.pages.overlay.validate")))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
      _c("span", { staticClass: "material-icons" }, [_vm._v("remove")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }